import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { opciones_traslado_control_calidad } from "../../../../../../../../utility/constants";
import { DecisionSwal } from "../../../../../../Utils/Utils/DecisionSwal";

const MostrarMensajeCambiarTipoTraslado = (onConfirmar) => {
    let mensaje = "Ya has ingresado cantidades a trasladar. ";
    mensaje +=
        "Si cambias el tipo de traslado se reiniciarán las cantidades ingresadas. ";
    mensaje += "¿Deseas continuar?";

    DecisionSwal(mensaje, "Sí, cambiar", "Cancelar", onConfirmar);
};

export const EncabezadoTraslado = ({ trasladoForm, nombreUsuario }) => {
    const { formControl, hayCantidadesIngresadas, fechaHoraBodega } =
        trasladoForm;

    return (
        <div className="traslado-control-calidad__encabezado">
            <h5 className="mb-3">Encabezado</h5>
            <div className="formulario-fields-row">
                <div className="formulario-field" style={{ minWidth: "220px" }}>
                    <label className="text-nowrap">Tipo de traslado</label>
                    <Controller
                        name="destino_es_conforme_bodega"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={opciones_traslado_control_calidad}
                                placeholder="Seleccionar"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                onChange={(selectedOption) => {
                                    const tipoActual = field.value;

                                    // Si realmente no cambió, no hacer nada
                                    if (
                                        (tipoActual && tipoActual.value) ===
                                        (selectedOption && selectedOption.value)
                                    ) {
                                        return;
                                    }

                                    const aplicarCambio = () =>
                                        field.onChange(selectedOption);

                                    if (hayCantidadesIngresadas) {
                                        MostrarMensajeCambiarTipoTraslado(
                                            aplicarCambio,
                                        );
                                    } else {
                                        aplicarCambio();
                                    }
                                }}
                            />
                        )}
                    />
                </div>

                <div className="formulario-field" style={{ minWidth: "120px" }}>
                    <label className="text-nowrap">Fecha</label>
                    <input
                        type="text"
                        className="form-control"
                        value={fechaHoraBodega.format("DD/MM/YYYY")}
                        disabled
                    />
                </div>

                <div className="formulario-field" style={{ minWidth: "120px" }}>
                    <label className="text-nowrap">Turno</label>
                    <input
                        type="text"
                        className="form-control"
                        value={
                            fechaHoraBodega.hour() < 18 ? "Diurno" : "Nocturno"
                        }
                        disabled
                    />
                </div>

                <div className="formulario-field" style={{ minWidth: "150px" }}>
                    <label className="text-nowrap">Supervisor</label>
                    <input
                        type="text"
                        className="form-control"
                        value={nombreUsuario}
                        disabled
                    />
                </div>
            </div>
        </div>
    );
};
